import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './par-school-level.reducer';
import { IParSchoolLevel } from 'app/shared/model/par-school-level.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParSchoolLevel = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const parSchoolLevelList = useAppSelector(state => state.parSchoolLevel.entities);
  const loading = useAppSelector(state => state.parSchoolLevel.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="par-school-level-heading" data-cy="ParSchoolLevelHeading">
        <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.home.title">Par School Levels</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.home.createLabel">Create new Par School Level</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {parSchoolLevelList && parSchoolLevelList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.type">Type</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {parSchoolLevelList.map((parSchoolLevel, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${parSchoolLevel.id}`} color="link" size="sm">
                      {parSchoolLevel.id}
                    </Button>
                  </td>
                  <td>{parSchoolLevel.code}</td>
                  <td>{parSchoolLevel.name}</td>
                  <td>{parSchoolLevel.nameAr}</td>
                  <td>{parSchoolLevel.nameEn}</td>
                  <td>{parSchoolLevel.type}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${parSchoolLevel.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${parSchoolLevel.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${parSchoolLevel.id}/edit`} color="primary" size="sm" data-cy="entityEditButton">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${parSchoolLevel.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.home.notFound">No Par School Levels found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ParSchoolLevel;
